
































































export default {
  name: "Banners",
  props: {
    banners: { type: Object, default: () => ({}) },
  },
};
